const actions = {
  async jitsiRecordingStarted({rootGetters, dispatch}, isCurrentUser) {
    dispatch('popups/show/confirm', {
      message: `A video download link will be sent to <br> <b>${isCurrentUser ? rootGetters['current_user/email'] : 'the recording initiators email'}</b> <br> when the meeting has ended`
    }, {root: true})
  },
  async jitsiError({dispatch}, message) {
    dispatch('popups/show/error', {message}, {root: true})
  }
};

export default {
  namespaced: true,
  actions
};
